import { Spinner } from 'react-bootstrap';
import ESpinner from './others/Spinner';

export default function Loader() {
    return (
        <div className="w-100 d-flex justify-content-center">   
            <ESpinner/>
        </div>
    );
}
